<template>
  <div>
    <div>
      <van-popup
        v-model="showModal"
        position="bottom"
        :style="{ height: '60%' }"
        closeable
        safe-area-inset-bottom
        @close="reset"
      >
        <van-form @submit="submit" class="mt-40" ref="formModelRef">
          <van-field
            v-model="formModel.fullName"
            clearable
            clear-trigger="focus"
            label-align="right"
            name="fullName"
            label-width="4.2em"
            size="large"
            label="姓名"
            maxlength="11"
            :rules="formModelRules.fullName"
            placeholder="请输入姓名"
          />
          <van-field
            v-model="formModel.mobile"
            clearable
            clear-trigger="focus"
            label-align="right"
            name="mobile"
            label-width="4.2em"
            size="large"
            label="手机号"
            type="digit"
            maxlength="11"
            :rules="formModelRules.mobile"
            placeholder="请输入手机号"
          />
          <van-field
            v-model.number="formModel.age"
            clearable
            clear-trigger="focus"
            label-align="right"
            name="age"
            label-width="4.2em"
            size="large"
            label="年龄"
            placeholder="请输入年龄"
            :rules="formModelRules.age"
            type="digit"
            maxlength="2"
          />
          <van-field
            label-align="right"
            name="gender"
            label-width="4.2em"
            size="large"
            label="性别"
          >
            <template #input>
              <van-radio-group v-model="formModel.gender" direction="horizontal" >
                <van-radio checked-color="#008c8c" :name="0" @click="formModel.gender = 0">男</van-radio>
                <van-radio checked-color="#008c8c" :name="1" @click="formModel.gender = 1">女</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </van-form>
        <div>
          <div class="wpercent100 bottom0 fixed">
            <bottom-btn leftText="取消" rightText="提交" @click="btnClick" />
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import BottomBtn from "@/components/basic/bottomBtn.vue";
import { checkChinese, checkPhone } from "@/utils/validate";
import { formModel } from "@/api/candidate/index";
export default {
  components: {
    BottomBtn,
  },
  props: {
    visible: {}, // 消息体
  },
  data() {
    return {
      // 展示此弹窗
      showModal: false,
      // 表单数据
      formModel: formModel,
      formModelRules:{
        fullName: [{ validator: checkChinese, message: '姓名只能为中文', trigger: 'onBlur' }], // 姓名为空验证
        mobile: [{ validator: checkPhone, message: '手机号格式不正确', trigger: 'onBlur' }], // 姓名为空验证
        age: [{ validator: (value) => { return value ? value > 17 : true}, message: '未成年不可进入', trigger: 'onBlur' }], // 姓名为空验证
      },
    };
  },
  // 从内部产生改变
  watch: {
    immediate: true,
    visible: {
      // eslint-disable-next-line no-unused-vars
      handler(val) {
        this.showModal = !this.showModal;
      },
    },
  },
  methods: {
    btnClick(val) {
      if (val === "leftText") {
        this.showModal = !this.showModal;
        this.formModel = this.resetForm(this.formModel); // 重置表单
      } else {
        this.submit(this.formModel);
      }
    },
    // 提交添加候选人
    submit(val) {
      this.$refs['formModelRef'].validate().then(() => {
        // 提交方法写这里，穿val对象
        console.log(val);
        this.reset();
      }).catch(() => {
        // 验证不通过组织，产生提示
        console.warn('验证不通过');
      });
    },
    // reset formModel
    reset(){
      this.formModel = this.resetForm(this.formModel); // 重置表单
      this.$refs['formModelRef'].resetValidation();
    },
    // 重置表单
    resetForm(object) {
      const obj = object;
      Object.keys(obj).forEach((key) => (obj[key] = ''))
      obj['gender'] = 0;
      return obj;
    }
  },
};
</script>

<style></style>
